var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.548 50.4408H24.4619L31.0417 40.1877H93.9863L100.548 50.4408Z",
    fill: "#D25C59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9229 50.4408H97.0001V86.0143H26.9229V50.4408Z",
    fill: "#EEEDED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8952 75.6204H69.1082V86.016H55.8952V75.6204Z",
    fill: "#A77A4E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0731 75.6186H53.9372L62.5141 67.8441L71.0731 75.6186Z",
    fill: "#CDCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7546 74.2806H57.2473L62.5084 69.5057L67.7546 74.2806Z",
    fill: "#EEEDED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7368 85.9965H105.202V91.6133H19.7368V85.9965Z",
    fill: "#9CCC65"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6463 86.521C34.0757 86.521 33.5765 86.2892 33.2555 85.9504C32.8702 86.0905 32.1892 86.0863 31.5972 85.8077C30.0264 87.2621 27.0858 86.3346 27.0858 84.4347C27.0858 82.6097 29.773 81.6937 31.401 82.8834C32.6169 82.2145 34.1251 82.6535 34.6285 83.6323H34.6463C37.0165 83.6323 36.9974 86.521 34.6463 86.521Z",
    fill: "#8EC163"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3853 85.3206C36.2034 86.5583 34.2495 87.0731 33.2292 86.123C32.997 86.1541 32.285 86.3349 31.6244 86.0517C30.8398 86.6758 29.7699 86.7828 28.8605 86.5331C27.9333 86.2657 27.0774 85.4811 27.0774 84.4825C27.2493 86.3402 30.07 87.0567 31.446 85.6416L31.553 85.5346C31.7329 85.5872 32.0815 85.9763 33.3362 85.8021L33.3718 85.8377C34.2192 86.8324 36.0982 86.5048 36.3853 85.3206Z",
    fill: "#7BA452"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3776 85.0767C97.3776 86.4306 95.2509 87.0562 94.2036 85.9506C93.8183 86.0908 93.1373 86.0865 92.5453 85.808C90.9746 87.2623 88.034 86.3349 88.034 84.435C88.034 82.6099 90.7212 81.6939 92.3492 82.8836C93.5651 82.2148 95.0733 82.6538 95.5767 83.6326C95.7553 83.696 97.3776 83.6996 97.3776 85.0767Z",
    fill: "#8EC163"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3506 85.3206C97.1293 86.5745 95.1869 87.0637 94.1766 86.1231C93.9534 86.151 93.2437 86.3397 92.5718 86.0517C90.8603 87.413 87.9422 86.3358 88.0426 84.4291C88.1098 86.3153 90.9982 87.0767 92.3935 85.6418L92.5005 85.5348C92.6804 85.5874 93.029 85.9765 94.2836 85.8023C94.4829 85.9269 94.8711 86.6232 96.0667 86.3907C96.6197 86.3015 97.1903 85.9093 97.3506 85.3206Z",
    fill: "#7BA452"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3398 79.9801H27.4079V85.9928H26.3398V79.9801Z",
    fill: "#A77A4E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4962 76.4499C28.4962 78.8809 27.7646 80.8414 26.8867 80.8414C26.6917 80.8414 26.472 80.7368 26.3013 80.5538C25.6917 79.9265 25.2527 78.332 25.2527 76.4499C25.2527 74.0188 25.9845 72.0322 26.8867 72.0322C26.911 72.0322 26.9354 72.0322 26.9599 72.0583C27.8134 72.1367 28.4962 74.0973 28.4962 76.4499Z",
    fill: "#8EC163"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0328 76.1885C28.0328 78.6195 27.3011 80.58 26.4233 80.58C26.3745 80.58 26.35 80.58 26.3012 80.5538C25.6915 79.9265 25.2525 78.332 25.2525 76.4499C25.2525 74.0188 25.9843 72.0322 26.8866 72.0322C26.9108 72.0322 26.9352 72.0322 26.9597 72.0583C27.5695 72.6335 28.0328 74.2802 28.0328 76.1885Z",
    fill: "#9CCC65"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8459 79.9801H21.914V85.9928H20.8459V79.9801Z",
    fill: "#A77A4E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0023 76.4499C23.0023 78.8809 22.2707 80.8414 21.3929 80.8414C21.1978 80.8414 20.9781 80.7368 20.8074 80.5538C20.1978 79.9265 19.7588 78.332 19.7588 76.4499C19.7588 74.0188 20.4906 72.0322 21.3929 72.0322C21.4171 72.0322 21.4415 72.0322 21.466 72.0583C22.3195 72.1367 23.0023 74.0973 23.0023 76.4499Z",
    fill: "#8EC163"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5391 76.1885C22.5391 78.6195 21.8074 80.58 20.9296 80.58C20.8807 80.58 20.8563 80.58 20.8074 80.5538C20.1978 79.9265 19.7588 78.332 19.7588 76.4499C19.7588 74.0188 20.4906 72.0322 21.3929 72.0322C21.4171 72.0322 21.4415 72.0322 21.466 72.0583C22.0756 72.6335 22.5391 74.2802 22.5391 76.1885Z",
    fill: "#9CCC65"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1462 78.1239H25.1113V85.9929H23.1462V78.1239Z",
    fill: "#A77A4E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1081 73.5043C27.1081 76.6858 25.7634 79.2515 24.1501 79.2515C23.7915 79.2515 23.388 79.1146 23.0741 78.8751C21.9536 78.0541 21.1469 75.9673 21.1469 73.5045C21.1469 70.3228 22.4918 67.723 24.1501 67.723C24.1946 67.723 24.2396 67.723 24.2843 67.7571C25.8531 67.8596 27.1081 70.4254 27.1081 73.5043Z",
    fill: "#7BA452"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2565 73.1622C26.2565 76.3436 24.9118 78.9092 23.2984 78.9092C23.2087 78.9092 23.1638 78.9092 23.0741 78.875C21.9536 78.054 21.1469 75.9672 21.1469 73.5044C21.1469 70.3227 22.4918 67.7229 24.1501 67.7229C24.1946 67.7229 24.2396 67.7229 24.2843 67.757C25.4049 68.5098 26.2565 70.6649 26.2565 73.1622Z",
    fill: "#8EC163"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M103.107 79.9801H104.175V85.9928H103.107V79.9801Z",
    fill: "#A77A4E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M105.263 76.4499C105.263 78.8809 104.532 80.8414 103.654 80.8414C103.459 80.8414 103.239 80.7368 103.068 80.5538C102.459 79.9265 102.02 78.332 102.02 76.4499C102.02 74.0188 102.751 72.0322 103.654 72.0322C103.678 72.0322 103.702 72.0322 103.727 72.0583C104.58 72.1367 105.263 74.0973 105.263 76.4499Z",
    fill: "#8EC163"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M104.8 76.1885C104.8 78.6195 104.068 80.58 103.19 80.58C103.141 80.58 103.117 80.58 103.068 80.5538C102.458 79.9265 102.019 78.332 102.019 76.4499C102.019 74.0188 102.751 72.0322 103.654 72.0322C103.678 72.0322 103.702 72.0322 103.727 72.0583C104.336 72.6335 104.8 74.2802 104.8 76.1885Z",
    fill: "#9CCC65"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6134 79.9801H98.6815V85.9928H97.6134V79.9801Z",
    fill: "#A77A4E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7694 76.4499C99.7694 78.8809 99.0378 80.8414 98.16 80.8414C97.9649 80.8414 97.7452 80.7368 97.5746 80.5538C96.9649 79.9265 96.5259 78.332 96.5259 76.4499C96.5259 74.0188 97.2577 72.0322 98.16 72.0322C98.1842 72.0322 98.2087 72.0322 98.2331 72.0583C99.0867 72.1367 99.7694 74.0973 99.7694 76.4499Z",
    fill: "#8EC163"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3062 76.1885C99.3062 78.6195 98.5746 80.58 97.6967 80.58C97.6479 80.58 97.6234 80.58 97.5746 80.5538C96.9649 79.9265 96.5259 78.332 96.5259 76.4499C96.5259 74.0188 97.2577 72.0322 98.16 72.0322C98.1842 72.0322 98.2087 72.0322 98.2331 72.0583C98.8427 72.6335 99.3062 74.2802 99.3062 76.1885Z",
    fill: "#9CCC65"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9118 78.1239H101.877V85.9929H99.9118V78.1239Z",
    fill: "#A77A4E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M103.875 73.5043C103.875 76.6858 102.531 79.2515 100.917 79.2515C100.559 79.2515 100.155 79.1146 99.8413 78.8751C98.7208 78.0541 97.9141 75.9673 97.9141 73.5045C97.9141 70.3228 99.2589 67.723 100.917 67.723C100.962 67.723 101.007 67.723 101.051 67.7571C102.62 67.8596 103.875 70.4254 103.875 73.5043Z",
    fill: "#7BA452"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M103.024 73.1622C103.024 76.3436 101.679 78.9092 100.066 78.9092C99.9759 78.9092 99.931 78.9092 99.8413 78.875C98.7208 78.054 97.9141 75.9672 97.9141 73.5044C97.9141 70.3227 99.2589 67.7229 100.917 67.7229C100.962 67.7229 101.007 67.7229 101.051 67.757C102.172 68.5098 103.024 70.6649 103.024 73.1622Z",
    fill: "#8EC163"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3806 81.3972C65.3806 81.7004 65.131 81.9322 64.8278 81.9322C64.5247 81.9322 64.2751 81.7004 64.2751 81.3972C64.2751 81.0941 64.5247 80.8623 64.8278 80.8623C65.131 80.8623 65.3806 81.0941 65.3806 81.3972Z",
    fill: "#EEEDED"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5364 85.4348H58.3427V85.9787H56.5364V85.4348Z",
    fill: "#EBB760"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3434 75.9336L57.8887 76.66H56.9914L56.5367 75.9336H58.3434Z",
    fill: "#FCCC67"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9911 76.66H57.8881V85.4348H56.9911V76.66Z",
    fill: "#FCCC67"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5364 75.624H58.3427V75.9343H56.5364V75.624Z",
    fill: "#EBB760"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5445 85.4348H68.3508V85.9787H66.5445V85.4348Z",
    fill: "#EBB760"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3501 75.9336L67.8956 76.66H66.9982L66.5436 75.9336H68.3501Z",
    fill: "#FCCC67"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9975 76.66H67.8944V85.4348H66.9975V76.66Z",
    fill: "#FCCC67"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5443 75.624H68.3506V75.9343H66.5443V75.624Z",
    fill: "#EBB760"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6685 55.6974H36.5214V65.8452H28.6685V55.6974Z",
    fill: "#FCCC67"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2307 56.4517H31.5559V59.4045H29.2307V56.4517Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3555 56.6104H31.4328V59.2476H29.3555V56.6104Z",
    fill: "#4A8BC9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4329 56.4517H33.7581V59.4045H31.4329V56.4517Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5558 56.6104H33.6332V59.2476H31.5558V56.6104Z",
    fill: "#4A8BC9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6332 56.4517H35.9584V59.4045H33.6332V56.4517Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M33.758 56.6104H35.8353V59.2476H33.758V56.6104Z",
    fill: "#4A8BC9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2307 59.2958H31.5559V62.2486H29.2307V59.2958Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3555 59.4526H31.4328V62.0899H29.3555V59.4526Z",
    fill: "#4A8BC9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4329 59.2958H33.7581V62.2486H31.4329V59.2958Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5558 59.4526H33.6332V62.0899H31.5558V59.4526Z",
    fill: "#4A8BC9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6332 59.2958H35.9584V62.2486H33.6332V59.2958Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M33.758 59.4526H35.8353V62.0899H33.758V59.4526Z",
    fill: "#4A8BC9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2307 62.1381H31.5559V65.0909H29.2307V62.1381Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3555 62.2968H31.4328V64.934H29.3555V62.2968Z",
    fill: "#4A8BC9"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4329 62.1381H33.7581V65.0909H31.4329V62.1381Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5558 62.2968H33.6332V64.934H31.5558V62.2968Z",
    fill: "#4A8BC9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6332 62.1381H35.9584V65.0909H33.6332V62.1381Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M33.758 62.2968H35.8353V64.934H33.758V62.2968Z",
    fill: "#4A8BC9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M33.8092 56.6104L30.9512 64.9333H29.665L32.523 56.6104H33.8092Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M35.3801 56.6104L32.5221 64.9333H31.8789L34.7371 56.6104H35.3801Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3541 55.6974H51.207V65.8452H43.3541V55.6974Z",
    fill: "#FCCC67"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9177 56.4517H46.2429V59.4045H43.9177V56.4517Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0424 56.6104H46.1197V59.2476H44.0424V56.6104Z",
    fill: "#4A8BC9"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1179 56.4517H48.4431V59.4045H46.1179V56.4517Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2427 56.6104H48.3201V59.2476H46.2427V56.6104Z",
    fill: "#4A8BC9"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3201 56.4517H50.6453V59.4045H48.3201V56.4517Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4432 56.6104H50.5205V59.2476H48.4432V56.6104Z",
    fill: "#4A8BC9"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9176 59.2958H46.2428V62.2486H43.9176V59.2958Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0424 59.4526H46.1197V62.0899H44.0424V59.4526Z",
    fill: "#4A8BC9"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1179 59.2958H48.4431V62.2486H46.1179V59.2958Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2427 59.4526H48.3201V62.0899H46.2427V59.4526Z",
    fill: "#4A8BC9"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3201 59.2958H50.6453V62.2486H48.3201V59.2958Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4432 59.4526H50.5205V62.0899H48.4432V59.4526Z",
    fill: "#4A8BC9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9176 62.1381H46.2428V65.0909H43.9176V62.1381Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0424 62.2968H46.1197V64.934H44.0424V62.2968Z",
    fill: "#4A8BC9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1179 62.1381H48.4431V65.0909H46.1179V62.1381Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2427 62.2968H48.3201V64.934H46.2427V62.2968Z",
    fill: "#4A8BC9"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3201 62.1381H50.6453V65.0909H48.3201V62.1381Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4432 62.2968H50.5205V64.934H48.4432V62.2968Z",
    fill: "#4A8BC9"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M48.4965 56.6104L45.6383 64.9333H44.3521L47.2103 56.6104H48.4965Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M50.0674 56.6104L47.2092 64.9333H46.5662L49.4242 56.6104H50.0674Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0403 55.6973H65.8932V65.8451H58.0403V55.6973Z",
    fill: "#FCCC67"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6053 56.4515H60.9305V59.4044H58.6053V56.4515Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7284 56.6102H60.8057V59.2475H58.7284V56.6102Z",
    fill: "#4A8BC9"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8056 56.4515H63.1308V59.4044H60.8056V56.4515Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9304 56.6102H63.0077V59.2475H60.9304V56.6102Z",
    fill: "#4A8BC9"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0061 56.4515H65.3313V59.4044H63.0061V56.4515Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1309 56.6102H65.2082V59.2475H63.1309V56.6102Z",
    fill: "#4A8BC9"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6053 59.2957H60.9305V62.2485H58.6053V59.2957Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7284 59.4525H60.8057V62.0898H58.7284V59.4525Z",
    fill: "#4A8BC9"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8056 59.2957H63.1308V62.2485H60.8056V59.2957Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9304 59.4525H63.0077V62.0898H60.9304V59.4525Z",
    fill: "#4A8BC9"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0061 59.2957H65.3313V62.2485H63.0061V59.2957Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1309 59.4525H65.2082V62.0898H63.1309V59.4525Z",
    fill: "#4A8BC9"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6053 62.1379H60.9305V65.0908H58.6053V62.1379Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7284 62.2966H60.8057V64.9339H58.7284V62.2966Z",
    fill: "#4A8BC9"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8056 62.1379H63.1308V65.0908H60.8056V62.1379Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9304 62.2966H63.0077V64.9339H60.9304V62.2966Z",
    fill: "#4A8BC9"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0061 62.1379H65.3313V65.0908H63.0061V62.1379Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1309 62.2966H65.2082V64.9339H63.1309V62.2966Z",
    fill: "#4A8BC9"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M63.1831 56.6102L60.3251 64.9332H59.0389L61.8969 56.6102H63.1831Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M64.7535 56.6102L61.8955 64.9332H61.2523L64.1104 56.6102H64.7535Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7294 55.6974H80.5823V65.8452H72.7294V55.6974Z",
    fill: "#FCCC67"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2904 56.4517H75.6156V59.4045H73.2904V56.4517Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4153 56.6104H75.4926V59.2476H73.4153V56.6104Z",
    fill: "#4A8BC9"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4926 56.4517H77.8179V59.4045H75.4926V56.4517Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6156 56.6104H77.6929V59.2476H75.6156V56.6104Z",
    fill: "#4A8BC9"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M77.693 56.4517H80.0182V59.4045H77.693V56.4517Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8178 56.6104H79.8951V59.2476H77.8178V56.6104Z",
    fill: "#4A8BC9"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2905 59.2958H75.6157V62.2486H73.2905V59.2958Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4153 59.4526H75.4926V62.0899H73.4153V59.4526Z",
    fill: "#4A8BC9"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4926 59.2958H77.8179V62.2486H75.4926V59.2958Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6156 59.4526H77.6929V62.0899H75.6156V59.4526Z",
    fill: "#4A8BC9"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M77.693 59.2958H80.0182V62.2486H77.693V59.2958Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8178 59.4526H79.8951V62.0899H77.8178V59.4526Z",
    fill: "#4A8BC9"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2905 62.1381H75.6157V65.0909H73.2905V62.1381Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4153 62.2968H75.4926V64.934H73.4153V62.2968Z",
    fill: "#4A8BC9"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4926 62.1381H77.8179V65.0909H75.4926V62.1381Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6156 62.2968H77.6929V64.934H75.6156V62.2968Z",
    fill: "#4A8BC9"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M77.693 62.1381H80.0182V65.0909H77.693V62.1381Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8178 62.2968H79.8951V64.934H77.8178V62.2968Z",
    fill: "#4A8BC9"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M77.8707 56.6104L75.0127 64.9333H73.7265L76.5845 56.6104H77.8707Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M79.4411 56.6104L76.5831 64.9333H75.9399L78.7981 56.6104H79.4411Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4163 55.6973H95.2692V65.8451H87.4163V55.6973Z",
    fill: "#FCCC67"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9794 56.4515H90.3046V59.4044H87.9794V56.4515Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1044 56.6102H90.1818V59.2475H88.1044V56.6102Z",
    fill: "#4A8BC9"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1799 56.4515H92.5051V59.4044H90.1799V56.4515Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3047 56.6102H92.3821V59.2475H90.3047V56.6102Z",
    fill: "#4A8BC9"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3804 56.4515H94.7056V59.4044H92.3804V56.4515Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5052 56.6102H94.5826V59.2475H92.5052V56.6102Z",
    fill: "#4A8BC9"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9796 59.2957H90.3048V62.2485H87.9796V59.2957Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1044 59.4525H90.1818V62.0898H88.1044V59.4525Z",
    fill: "#4A8BC9"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1799 59.2957H92.5051V62.2485H90.1799V59.2957Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3047 59.4525H92.3821V62.0898H90.3047V59.4525Z",
    fill: "#4A8BC9"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3804 59.2957H94.7056V62.2485H92.3804V59.2957Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5052 59.4525H94.5826V62.0898H92.5052V59.4525Z",
    fill: "#4A8BC9"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9796 62.1379H90.3048V65.0908H87.9796V62.1379Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1044 62.2966H90.1818V64.9339H88.1044V62.2966Z",
    fill: "#4A8BC9"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1799 62.1379H92.5051V65.0908H90.1799V62.1379Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3047 62.2966H92.3821V64.9339H90.3047V62.2966Z",
    fill: "#4A8BC9"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3804 62.1379H94.7056V65.0908H92.3804V62.1379Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5052 62.2966H94.5826V64.9339H92.5052V62.2966Z",
    fill: "#4A8BC9"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M92.5584 56.6102L89.7002 64.9332H88.414L91.2722 56.6102H92.5584Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M94.1287 56.6102L91.2706 64.9332H90.6276L93.4856 56.6102H94.1287Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7889 47.4992V39.0748L44.7517 34.3732L39.719 39.0748V47.4992H49.7889Z",
    fill: "#FCCC67"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9852 39.635L50.5052 41.222L44.7457 35.8548L39.004 41.222L37.524 39.635L44.7457 32.8948L51.9852 39.635Z",
    fill: "#EBB760"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7678 39.6172H47.7413V45.5907H41.7678V39.6172Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3009 40.1504H47.2081V45.0576H42.3009V40.1504Z",
    fill: "#4A8BC9"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M45.8591 40.1504L43.4051 45.0572H42.301L44.7548 40.1504H45.8591Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M47.2077 40.1504L44.754 45.0572H44.2017L46.6557 40.1504H47.2077Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2899 47.4992V39.0748L80.2525 34.3732L75.22 39.0748V47.4992H85.2899Z",
    fill: "#FCCC67"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4867 39.635L86.0066 41.222L80.2472 35.8548L74.5054 41.222L73.0254 39.635L80.2472 32.8948L87.4867 39.635Z",
    fill: "#EBB760"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2697 39.6172H83.2431V45.5907H77.2697V39.6172Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8029 40.1504H82.7101V45.0576H77.8029V40.1504Z",
    fill: "#4A8BC9"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M81.3614 40.1504L78.9074 45.0572H77.8032L80.2571 40.1504H81.3614Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M82.7099 40.1504L80.2559 45.0572H79.7039L82.1576 40.1504H82.7099Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6685 72.6016H36.5214V82.7494H28.6685V72.6016Z",
    fill: "#FCCC67"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2307 73.3558H31.5559V76.3087H29.2307V73.3558Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3555 73.5145H31.4328V76.1518H29.3555V73.5145Z",
    fill: "#4A8BC9"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4329 73.3558H33.7581V76.3087H31.4329V73.3558Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5558 73.5145H33.6332V76.1518H31.5558V73.5145Z",
    fill: "#4A8BC9"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6332 73.3558H35.9584V76.3087H33.6332V73.3558Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M33.758 73.5145H35.8353V76.1518H33.758V73.5145Z",
    fill: "#4A8BC9"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2307 76.1981H31.5559V79.151H29.2307V76.1981Z",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3555 76.3568H31.4328V78.9941H29.3555V76.3568Z",
    fill: "#4A8BC9"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4329 76.1981H33.7581V79.151H31.4329V76.1981Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5558 76.3568H33.6332V78.9941H31.5558V76.3568Z",
    fill: "#4A8BC9"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6332 76.1981H35.9584V79.151H33.6332V76.1981Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M33.758 76.3568H35.8353V78.9941H33.758V76.3568Z",
    fill: "#4A8BC9"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2307 79.0422H31.5559V81.9951H29.2307V79.0422Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3555 79.1992H31.4328V81.8365H29.3555V79.1992Z",
    fill: "#4A8BC9"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4329 79.0422H33.7581V81.9951H31.4329V79.0422Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5558 79.1992H33.6332V81.8365H31.5558V79.1992Z",
    fill: "#4A8BC9"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6332 79.0422H35.9584V81.9951H33.6332V79.0422Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M33.758 79.1992H35.8353V81.8365H33.758V79.1992Z",
    fill: "#4A8BC9"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M33.8092 73.514L30.9512 81.837H29.665L32.523 73.514H33.8092Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M35.3801 73.514L32.5221 81.837H31.8789L34.7371 73.514H35.3801Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3541 72.6016H51.207V82.7494H43.3541V72.6016Z",
    fill: "#FCCC67"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9177 73.3558H46.2429V76.3087H43.9177V73.3558Z",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0424 73.5145H46.1197V76.1518H44.0424V73.5145Z",
    fill: "#4A8BC9"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1179 73.3558H48.4431V76.3087H46.1179V73.3558Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2427 73.5145H48.3201V76.1518H46.2427V73.5145Z",
    fill: "#4A8BC9"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3201 73.3558H50.6453V76.3087H48.3201V73.3558Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4432 73.5145H50.5205V76.1518H48.4432V73.5145Z",
    fill: "#4A8BC9"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9176 76.1981H46.2428V79.151H43.9176V76.1981Z",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0424 76.3568H46.1197V78.9941H44.0424V76.3568Z",
    fill: "#4A8BC9"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1179 76.1981H48.4431V79.151H46.1179V76.1981Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2427 76.3568H48.3201V78.9941H46.2427V76.3568Z",
    fill: "#4A8BC9"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3201 76.1981H50.6453V79.151H48.3201V76.1981Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4432 76.3568H50.5205V78.9941H48.4432V76.3568Z",
    fill: "#4A8BC9"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9176 79.0422H46.2428V81.9951H43.9176V79.0422Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0424 79.1991H46.1197V81.8364H44.0424V79.1991Z",
    fill: "#4A8BC9"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1179 79.0422H48.4431V81.9951H46.1179V79.0422Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2427 79.1991H48.3201V81.8364H46.2427V79.1991Z",
    fill: "#4A8BC9"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3201 79.0422H50.6453V81.9951H48.3201V79.0422Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4432 79.1991H50.5205V81.8364H48.4432V79.1991Z",
    fill: "#4A8BC9"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M48.4965 73.514L45.6383 81.837H44.3521L47.2103 73.514H48.4965Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M50.0674 73.514L47.2092 81.837H46.5662L49.4242 73.514H50.0674Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7294 72.6016H80.5823V82.7494H72.7294V72.6016Z",
    fill: "#FCCC67"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2904 73.3558H75.6156V76.3087H73.2904V73.3558Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4153 73.5145H75.4926V76.1518H73.4153V73.5145Z",
    fill: "#4A8BC9"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4926 73.3558H77.8179V76.3087H75.4926V73.3558Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6156 73.5145H77.6929V76.1518H75.6156V73.5145Z",
    fill: "#4A8BC9"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M77.693 73.3558H80.0182V76.3087H77.693V73.3558Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8178 73.5145H79.8951V76.1518H77.8178V73.5145Z",
    fill: "#4A8BC9"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2905 76.1981H75.6157V79.151H73.2905V76.1981Z",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4153 76.3568H75.4926V78.9941H73.4153V76.3568Z",
    fill: "#4A8BC9"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4926 76.1981H77.8179V79.151H75.4926V76.1981Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6156 76.3568H77.6929V78.9941H75.6156V76.3568Z",
    fill: "#4A8BC9"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M77.693 76.1981H80.0182V79.151H77.693V76.1981Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8178 76.3568H79.8951V78.9941H77.8178V76.3568Z",
    fill: "#4A8BC9"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2905 79.0422H75.6157V81.9951H73.2905V79.0422Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4153 79.1991H75.4926V81.8364H73.4153V79.1991Z",
    fill: "#4A8BC9"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4926 79.0422H77.8179V81.9951H75.4926V79.0422Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6156 79.1991H77.6929V81.8364H75.6156V79.1991Z",
    fill: "#4A8BC9"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M77.693 79.0422H80.0182V81.9951H77.693V79.0422Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8178 79.1991H79.8951V81.8364H77.8178V79.1991Z",
    fill: "#4A8BC9"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M77.8707 73.514L75.0127 81.837H73.7265L76.5845 73.514H77.8707Z",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M79.4411 73.514L76.5831 81.837H75.9399L78.7981 73.514H79.4411Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4163 72.6017H95.2692V82.7495H87.4163V72.6017Z",
    fill: "#FCCC67"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9794 73.3558H90.3046V76.3087H87.9794V73.3558Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1044 73.5145H90.1818V76.1518H88.1044V73.5145Z",
    fill: "#4A8BC9"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1799 73.3558H92.5051V76.3087H90.1799V73.3558Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3047 73.5145H92.3821V76.1518H90.3047V73.5145Z",
    fill: "#4A8BC9"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3804 73.3558H94.7056V76.3087H92.3804V73.3558Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5052 73.5145H94.5826V76.1518H92.5052V73.5145Z",
    fill: "#4A8BC9"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9796 76.1981H90.3048V79.151H87.9796V76.1981Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1044 76.3568H90.1818V78.9941H88.1044V76.3568Z",
    fill: "#4A8BC9"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1799 76.1981H92.5051V79.151H90.1799V76.1981Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3047 76.3568H92.3821V78.9941H90.3047V76.3568Z",
    fill: "#4A8BC9"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3804 76.1981H94.7056V79.151H92.3804V76.1981Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5052 76.3568H94.5826V78.9941H92.5052V76.3568Z",
    fill: "#4A8BC9"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9796 79.0422H90.3048V81.9951H87.9796V79.0422Z",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1044 79.1991H90.1818V81.8364H88.1044V79.1991Z",
    fill: "#4A8BC9"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1799 79.0422H92.5051V81.9951H90.1799V79.0422Z",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3047 79.1991H92.3821V81.8364H90.3047V79.1991Z",
    fill: "#4A8BC9"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3804 79.0422H94.7056V81.9951H92.3804V79.0422Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5052 79.1991H94.5826V81.8364H92.5052V79.1991Z",
    fill: "#4A8BC9"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M92.5584 73.514L89.7002 81.837H88.414L91.2722 73.514H92.5584Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M94.1287 73.514L91.2706 81.837H90.6276L93.4856 73.514H94.1287Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.331e6d3bf1b15c14ebaad88c9c5c1c2d.svg";
export { ForwardRef as ReactComponent };